import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LacertaMapperPipe } from './mapper.pipe';

@NgModule({
  declarations: [LacertaMapperPipe],
  exports: [LacertaMapperPipe],
  imports: [CommonModule],
})
export class LacertaMapperModule {}
